<template>
  <div class="box">
    <template v-if="buttonList">
      <el-checkbox
        v-for="(item,index) in buttonList"
        @change="checkChange" :key="index"
        :disabled="disabled"
        v-model="item.check"
        :label="item.buttonName" ></el-checkbox>
    </template>

  </div>
</template>
<script>
export default {
  props: {
    buttonList: {
      type: Array
    },
    defaultBtnKeys: {
      type: Object || null
    },
    node: { // 父节点的树节点
      type: Object
    },
    disabled: {
      type: Boolean || null
    }
  },
  data: function () {
    return {
      // btnList: null
    }
  },
  methods: {
    checkChange (value) {
      console.log('check变化了：', value)
      if (value) {
        // 这里修改后自动会引起页面的刷新变化
        this.node.checked = true
      }
      this.$nextTick(() => {
        this.$emit('updateIDs')
      })
    },
    initCheck () {
      if (this.disabled) {
        // disable为true表示只是展示，不让做勾选操作
        this.buttonList.map(item => {
          this.$set(item, 'check', true)
          return item
        })
      } else {
        this.buttonList.map(item => {
          this.$set(item, 'check', this.defaultBtnKeys ? item.buttonId in this.defaultBtnKeys : false)
          return item
        })
      }

      // this.btnList = Object.assign([], this.buttonList)
    }
  },
  created () {
    this.initCheck()
  },
  watch: {
    defaultBtnKeys () {
      console.log('defaultBtnKeysb变化了：')
      this.initCheck()
    },
    buttonList () {
      console.log('buttonList改变')
    }
  }
}
</script>
<style lang="less">
  .box{
    // white-space: break-spaces;
    // padding: 10px 0px;
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-tree-node__content{
      height: auto !important;
      //min-height: 26px;
      max-height: 200px;
      align-items: flex-start;
      padding-top: 4px;
    }
</style>
